// extracted by mini-css-extract-plugin
export const accountBadge = "AccountBadge__accountBadge__kBRQT";
export const accountName = "AccountBadge__accountName__iYmC8";
export const accountNameInner = "AccountBadge__accountNameInner__9Y6V4";
export const atlasGrotesk = "'AtlasGrotesk'";
export const baseAccountName = "AccountBadge__baseAccountName__pa+5-";
export const bold = "700";
export const cardDetails = "AccountBadge__cardDetails__fEi0Y";
export const details = "AccountBadge__details__t+97b";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "AccountBadge__textCenter__aztqI";
export const tooltipIconWrapper = "AccountBadge__tooltipIconWrapper__Iag2e";